<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">{{ 'home.changelog.hero.kicker' | translate }}</div>
      <h1 class="hero__title">{{ 'home.changelog.hero.title' | translate }}</h1>
      <p class="hero__subtitle">{{ 'home.changelog.hero.subtitle' | translate }}</p>
    </div>
  </header>

  <section class="section timeline">
    @for (entry of entries; track entry.version) {
      <mat-card class="card--release" appearance="outlined">
        <mat-card-header class="release__header" id="v{{ entry.version }}">
          <div class="release__meta">
            <span class="release__version">v{{ entry.version }}</span>
            <span class="release__date">{{ entry.date | date:'dd.MM.yyyy' }}</span>
          </div>
          @if (entry.title) {
            <h2 class="release__title">{{ entry.title }}</h2>
          }
        </mat-card-header>

        <mat-card-content>
          <ul class="changes">
            @for (change of entry.changes; track $index) {
              <li class="change">{{ change }}</li>
            }
          </ul>
        </mat-card-content>
      </mat-card>
    }
  </section>

</section>
